import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { FileWithPayload, PathParamsWithId } from "commons/types/api/common";

function useMediaApi() {
    const { get } = useHttpManaged();
    const getOne = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<FileWithPayload> => {
        return get<PathParamsWithId, undefined, FileWithPayload>({
            url: "/media-binary/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [get]);
    return {
        getOne
    };
}

export default useMediaApi;